const Empty = ({
  message = "검색어와 일치하는 게시물이 없습니다.",
  show = true,
}: {
  message?: string;
  show?: boolean;
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className="flex-1 flex justify-center items-center">
      <p className="text-center text-20 text-secondary">{message}</p>
    </div>
  );
};

export default Empty;
